import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useAccessToken, useCurrentUser } from '@/features/auth/state/auth'
import api from '@/lib/api'

interface UpdateParams {
  id_client: string
  update: any
}

export function useUpdateClientStatus() {
  const queryClient = useQueryClient()
  const user = useCurrentUser()
  const token = useAccessToken()

  return useMutation({
    mutationFn: async ({ id_client, update }: UpdateParams) => {
      if (!user || !token) throw new Error('Usuário não autenticado')

      const body = {
        status: update.status
      }

      const response = await api.post(`/clients/update/${id_client}`, body, {
        headers: { Authorization: `Bearer ${token}` }
      })

      if (response.data) {
        return response.data
      } else {
        throw new Error('Erro ao atualizar cliente')
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['clients'] })
    }
  })
}
